// extracted by mini-css-extract-plugin
export default {"tagline":"styles_tagline__Zm+Jo"};